import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { WidgetTypeEnum } from '@/types/schema';

import { geti18nKey } from '../../../HomepageStack/components/StackEmptyState';
import EmptyStateListItem from './EmptyStateListItem';

const ListEmptyState = ({
  widgetType,
  transparentBackground,
}: {
  widgetType: WidgetTypeEnum;
  transparentBackground?: boolean;
}) => {
  const { isMobile } = useScreen();

  const i18nKey = geti18nKey(widgetType);
  const { t } = useTranslation();

  if (isMobile && widgetType === WidgetTypeEnum.Calendar) {
    return (
      <Stack className="h-full relative">
        <Stack
          className={cn(
            'w-full min-h-[330px] rounded-16 border border-border mt-16',
            transparentBackground ? '!bg-bg-transparent' : 'bg-bg-primary',
          )}
          direction="col">
          <Stack className="">
            <Typography
              className={cn(
                'w-[200px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-text-placeholder text-center',
                transparentBackground ? '!bg-bg-transparent' : 'bg-bg-primary',
              )}
              variant="label-02">
              {t(i18nKey)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack className={cn('h-full relative', transparentBackground ? '!bg-bg-transparent' : '')}>
      <Stack className="w-full h-full" direction="col">
        <EmptyStateListItem />
        <Stack>
          <Typography
            className={cn(
              'w-[200px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-text-placeholder text-center',
              transparentBackground ? '!bg-bg-transparent' : 'bg-bg-primary ',
            )}
            variant="label-02">
            {t(i18nKey)}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ListEmptyState;
